import type { z } from 'zod';

import type { DeviationWithVINSchema } from './zod';

export type DeviationWithVIN = z.infer<ReturnType<typeof DeviationWithVINSchema>>;

export interface DialogProps {
    show: boolean;
    errorStatus?: number;
    onCancel?: () => void;
    onConfirm: () => void;
}

export enum SystemAdminDialogTypes {
    EDIT_FLEET = 'EDIT_FLEET',
    FLEET_DIALOG = 'FLEET_DIALOG',
    EXIT_CONFIRMATION = 'EXIT_CONFIRMATION',
    ERROR_DIALOG = 'ERROR_DIALOG',
    DELETE_USER_DIALOG = 'DELETE_USER_DIALOG',
    DELETE_USER_ERROR = 'DELETE_USER_ERROR',
    RESET_PASSWORD_DIALOG = 'RESET_PASSWORD_DIALOG',
    RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR',
}

export enum SystemAdminFormTypes {
    EDIT_FORM = 'EDIT_FORM',
    CREATE_FORM = 'CREATE_FORM',
}

export enum EnvironmentTypes {
    PRODUCTION = 'production',
    PREPROD = 'preprod',
    STAGING = 'staging',
    LOCAL = 'development',
}
